export default "__VITE_ASSET__6063084d__"